enum ApiTokenFieldNames {
  Label = 'label',
}

export default ApiTokenFieldNames;
